export default "__VITE_ASSET__BdkoEn6a__"